var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00775 10.983C4.1074 12.5974 5.6048 13.4046 7.49994 13.4046C9.39508 13.4046 10.8925 12.5974 11.9921 10.983C11.9687 10.3279 11.4423 9.7781 10.4128 9.33356C9.38338 8.88902 8.41241 8.66675 7.49994 8.66675C6.58746 8.66675 5.6165 8.88902 4.58704 9.33356C3.55758 9.7547 3.03115 10.3045 3.00775 10.983ZM9.07922 3.43756C8.63468 2.99302 8.10826 2.77075 7.49994 2.77075C6.89162 2.77075 6.36519 2.99302 5.92065 3.43756C5.47612 3.8821 5.25385 4.40853 5.25385 5.01685C5.25385 5.62516 5.47612 6.15159 5.92065 6.59613C6.36519 7.04067 6.89162 7.26294 7.49994 7.26294C8.10826 7.26294 8.63468 7.04067 9.07922 6.59613C9.52376 6.15159 9.74603 5.62516 9.74603 5.01685C9.74603 4.40853 9.52376 3.8821 9.07922 3.43756ZM2.20056 2.73566C3.67456 1.26166 5.44102 0.524658 7.49994 0.524658C9.55886 0.524658 11.3136 1.26166 12.7642 2.73566C14.2382 4.18626 14.9752 5.94102 14.9752 7.99994C14.9752 10.0589 14.2382 11.8253 12.7642 13.2993C11.3136 14.7499 9.55886 15.4752 7.49994 15.4752C5.44102 15.4752 3.67456 14.7499 2.20056 13.2993C0.749959 11.8253 0.0246582 10.0589 0.0246582 7.99994C0.0246582 5.94102 0.749959 4.18626 2.20056 2.73566Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.d31d641d8db7e389200c558304f4be85.svg";
export { ForwardRef as ReactComponent };